import styled from "styled-components";

export const GroupHighlightSlidesLoadingSkeletonContainer = styled.div`
  z-index: 1;
  position: relative;

  ul {
    display: flex;
    gap: 12px;

    margin-top: 1rem;
    margin-bottom: 0;

    @media (max-width: 800px) {
      max-width: 100vw;
    }

    li {
      list-style: none;
    }
  }
`;
